module.exports = __webpack_public_path__ + "img/Chris.f2e08a04.png";